import { ThemeTypes } from "./themes.model";

export class UserProfileCompany {
  public companyId?: number;
  public name: string;
  public address: string;
  public city: string;
  public stateAbbr: string;
  public stateId: number;
  public postalCode: string;
  public region: string;
  public companySize: string;
  public countryId: number;
  public industryId: number;
}

export interface UserProfileInfo {
  id?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  title?: string;
  phoneNumber?: string;
  userImagePath?: string;
  userImagePathUrl?: string;
  clientAddressDetailsId?: number;
  company?: UserProfileCompany;
  clientId?: number;
  uiTheme?: ThemeTypes;
  newsLetter?:NewsLetterConfig;
}


export interface NewsLetterConfig {
    emailID: string;
    industries: number[]
    topics: number[]

}

export interface PermisisonObject {
  permission: AccessPermission;
  accessItemName: FeatureAccessItemEnum;
}

type ItemPermissions = 'Module' | 'Reports' | string;
export enum AccessPermission {
  ADD_EDIT = 'addEditAccessValue',
  VIEW = 'viewAccessValue',
  DOWNLOAD_PRINT = 'downloadPrintAccessValue',
};
export type AccessItem = {
  itemId: number;
  itemName: string;
  itemParentId: number;
  itemPermissions: ItemPermissions;
  addEditAccessId?: AccessIdEnum;
  addEditAccessValue?: string;
  viewAccessId: AccessIdEnum;
  viewAccessValue: string;
  downloadPrintAccessId: AccessIdEnum;
  downloadPrintAccessValue: string;
};

export enum AccessIdEnum {
  DENIED = 2,
  ENABLED = 1,
  DISABLED = 0.
}


export interface UserProfileRoleAccesses extends UserProfileInfo {
  contactInformation: string;
  market: string;
  marketId: number;
  lagRoleId: number;
  roleType: string;
  lastLoginDate: string;
  accessStartDate: string;
  accessEndDate?: string;
  accessItems: AccessItem[];
  activeStatus: boolean;
  reportAccess: string;
  moduleAccess: string;
}

export enum FeatureAccessItemEnum {
  Profiles = "Profiles",
  CreateAProfile = "Create a Profile",
  ViewProfiles = "View Profiles",
  Articles = "Articles",
  Competition = "Competition",
  Interviews = "Interviews",
  Multisite = "Multisite",
  Benchmark = "Benchmark",
  FeaturedReport = "Featured Report",
  DataDictionary = "Data Dictionary",
  LaborPlan = "LaborPlan<sup>&trade;</sup>",
  MarketReports = "Market Reports",
  DownloadData = "Download Data",
  Supply = "Supply",
  Demand = "Demand",
  BusinessEnvironment = "Business Environment",
  VersionHistory = "Version History",
  AboutUs = "About Us",
  FAQ = "FAQ",
  LegalPrivacyInformation = "Legal privacy information",
  ManageUserProfiles = "Manage user profiles",
  GeoSkill = "GeoSkill"
}
